import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito mucho dinero para empezar?',
    a: 'No, el protocolo te enseña a recuperar dinero que ya estás perdiendo.'
  }, {
    q: '¿Cuánto tiempo al día requiere?',
    a: 'Menos de 15 minutos de gestión, el resto es vivir con una nueva mentalidad.'
  }, {
    q: '¿Es difícil de seguir?',
    a: 'Está diseñado para personas extremadamente ocupadas; se basa en la simplicidad radical.'
  }, {
    q: '¿Qué pasa si fallo un día?',
    a: 'El manual incluye el protocolo de reinicio inmediato para no perder el impulso.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-tactical-panel border-b border-tactical-border" data-id="element-34">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-35">
        <FadeIn data-id="element-36">
          <div className="text-center mb-12" data-id="element-37">
            <h2 className="text-4xl font-bold uppercase mb-4" data-id="element-38">
              Intel / <span className="text-tactical-accent" data-id="element-39">FAQ</span>
            </h2>
            <p className="text-zinc-400 font-mono uppercase text-sm tracking-widest" data-id="element-40">
              Respuestas tácticas a dudas comunes
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-42">
              <div className="bg-tactical-dark border border-zinc-800 overflow-hidden" data-id="element-43">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-zinc-900 transition-colors focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-44">
                  <span className="font-oswald text-lg uppercase tracking-wide text-zinc-200" data-id="element-45">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-tactical-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-46" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-47">
                  <p className="text-zinc-400 border-l-2 border-tactical-accent pl-4" data-id="element-48">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}